export default __webpack_public_path__ + "static/media/06.96f17a22.jpg";